import { useState } from 'react';
import { Building2 } from 'lucide-react';

export default function CompanyDetailsForm({ profile, updateProfile }) {
  const [formData, setFormData] = useState({
    name: profile?.name || '',
    owner_name: profile?.owner_name || '',
    phone: profile?.phone || '',
    email: profile?.email || '',
    website_url: profile?.website_url || '',
    street_1: profile?.street_1 || '',
    street_2: profile?.street_2 || '',
    location_text: profile?.location_text || '',
    zip_code: profile?.zip_code || '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    updateProfile(formData);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <h2 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Building2 className="w-5 h-5 text-teal-600" />
        Company Details
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input label="Company name" name="name" value={formData.name} onChange={handleChange} />
        <Input label="Owner name" name="owner_name" value={formData.owner_name} onChange={handleChange} />
        <Input label="Phone number" name="phone" value={formData.phone} onChange={handleChange} type="tel" />
        <Input label="Email address" name="email" value={formData.email} onChange={handleChange} type="email" />
        <Input label="Website URL" name="website_url" value={formData.website_url} onChange={handleChange} placeholder="https://" />
        <Input label="Street 1" name="street_1" value={formData.street_1} onChange={handleChange} />
        <Input label="Street 2" name="street_2" value={formData.street_2} onChange={handleChange} />
        <Input label="Location text" name="location_text" value={formData.location_text} onChange={handleChange} />
        <Input label="Zip code" name="zip_code" value={formData.zip_code} onChange={handleChange} />
      </div>

      <button onClick={handleSave} className="mt-6 px-5 py-2.5 bg-teal-600 text-white rounded-lg text-xs font-bold">
        Save Company Details
      </button>
    </div>
  );
}

const Input = ({ label, ...props }) => (
  <div>
    <label className="block text-xs font-medium text-gray-700 mb-1">{label}</label>
    <input
      className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500/20 focus:border-teal-500 text-sm"
      {...props}
    />
  </div>
);